import { useAtom } from '@reatom/npm-react'

import { dateByMinuteAtom, dateBySecondAtom } from '../reatom'

export const useCurrentDate = ({
  updateInterval = 'second',
}: {
  updateInterval?: 'second' | 'minute'
}) => {
  const [date] = useAtom(
    updateInterval === 'second' ? dateBySecondAtom : dateByMinuteAtom,
  )

  return date
}
